const BowUse = require('../ability_trees/BowUse.js');
const MeleeCombat = require('../ability_trees/MeleeCombat.js');
const Movement = require('../ability_trees/Movement.js');
const StandardAbilityTree = require('../ability_trees/StandardAbilityTree.js');

const ItemGenerator = require('../../game_items/ItemGenerator.js');
const MedHelmet = require('../../game_items/equipment/helmet/MedHelmet.js');
const MedTorsoe = require('../../game_items/equipment/torsoe/MedTorsoe.js');
const MedBoots = require('../../game_items/equipment/boots/MedBoots.js');
const Sword = require('../../game_items/equipment/weapon/Sword.js');
const Bow = require('../../game_items/equipment/off_hand/Bow.js');

module.exports = {
  handle: 'mercenary',
  getAbilityTrees: () => ([
    BowUse,
    MeleeCombat,
    Movement,
    StandardAbilityTree,
  ]),
  getBaseAttributes: () => ({
    learning: 6,
    perception: 9,
    mana: 4,
    toughness: 8,
    strength: 9,
    willpower: 4,
    dexterity: 10,
  }),
  getDefaultAIConfig: () => (['dps_ranged', 'dps_close', 'interference', 'tank', 'support']),
  getStarterEquipment: () => ({
    helmet: ItemGenerator.getRandomItem(MedHelmet, 0, 0.1, true),
    torsoe: ItemGenerator.getRandomItem(MedTorsoe, 0, 0.1, true),
    boots: ItemGenerator.getRandomItem(MedBoots, 0, 0.1, true),
    weapon: ItemGenerator.getRandomItem(Sword, 0, 0.1, true),
    off_hand: ItemGenerator.getRandomItem(Bow, 0, 0.1, true),
  }),
};
